import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "deplier",
  "use": "deplier-usage",
  "viewBox": "0 0 21 21",
  "content": "<symbol viewBox=\"0 0 21 21\" xmlns=\"http://www.w3.org/2000/svg\" id=\"deplier\">\n  <g fill=\"none\" fill-rule=\"evenodd\">\n    <g>\n      <circle fill=\"#FFF\" cx=\"10.5\" cy=\"10.5\" r=\"10.5\" />\n      <path stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M14.62 9.13l-4.115 3.88-4.114-3.88\" />\n    </g>\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/deplier.svg
// module id = 434
// module chunks = 0